import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import {URLSearchParams} from '@angular/http';


@Component({
  selector: 'app-listorder',
  templateUrl: './listorder.component.html',
  styleUrls: ['./listorder.component.css']
})
export class ListorderComponent implements OnInit {

  ListCustomer: any = {};	
  paging: any = {};	
  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  alert_act='';
  alert_actmsg='';

  _STBdata: any = {
    'sn': ''
  };	
  
  flagging:any = {};

  table_load = true;
  errorsubmited = false;
  successsubmited = false;

  meta = [];
  self = [];
  
  
  constructor(public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
   
    private router: Router
    ) { }

  ngOnInit() {
    this.loadStart();
  }

  refreshPage() {
   // this.ngOnInit();
    this.loadStart();
  }

  _services(item: any)
  {
    let service = '';
    if ( item.services == null || item.services == 0 ){
      return service;
    }else{
      item.services.forEach(function (value: any) {
        service += value.servicename + '\n';
      });

      return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    }
  }
  
  isPairing(item: any)
  {
    return (item.services != null);
  }

  loadStart() {

    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        //console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          //console.log('search');
          //console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadbuyer(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          //console.log(this.queryParams);
          //console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadbuyer(this.queryParams);
        }
      });

    //this.table_load = true
    
  }
  
  queryStr(options){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  search()
  {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams+'&search='+this.msearch;
    this.loadbuyer(this.searchQueryParams);
  }

  loadcustomer(queryParams: any)
  {
    this.table_load = true
    return this.partnerService.GetListallcust(queryParams).subscribe((output: any) => {
        this.ListCustomer = output.data;
        console.log(output);
        this.table_load = false
        //this.customerid = this.ViewSTB.data.customer.id;

        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta['totalCount'];
        let self = this.page_self['page'];
        if ( self * this.meta['perPage'] < this.meta['totalCount']){
          this.last_index = (self * this.meta['perPage']);
        }else{
          this.last_index = this.meta['totalCount'];
        }
        
        this.first_index = ((self-1)*this.meta['perPage'])+1;
      })
  }

  _STB(item: any){
    // console.log(item);
    if (!item.stb ) {
      return '-'
    }else{
      return item.stb
    }
    // this._STBdata = item; 
    // return this._STBdata;
  }

  onActionClick(act:any, item: any)
  {
    this.alert_act = act;
    console.log(act);

    // if ( act == "setkondisi" || act == "approve") {
    //   this.formApprove.reset()
    //   this.itemstb = item
    // }
  }


  loadbuyer(queryParams: any)
  {
    this.table_load = true
    return this.partnerService.GetPlayboxOrder(queryParams).subscribe((output: any) => {
        this.ListCustomer = output.data;
        //console.log(output);
        this.table_load = false
        //this.customerid = this.ViewSTB.data.customer.id;

        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta['totalCount'];
        let self = this.page_self['page'];
        if ( self * this.meta['perPage'] < this.meta['totalCount']){
          this.last_index = (self * this.meta['perPage']);
        }else{
          this.last_index = this.meta['totalCount'];
        }
        
        this.first_index = ((self-1)*this.meta['perPage'])+1;
      })
  }

  submitValsys(item)
  {
    console.log(item);
    this.setflag(item.id,'errorsubmited',false);
    this.setflag(item.id,'successsubmited',false);
    this.setflag(item.id,'prosessubmit',true);
    let params = {trx_id:item.id};
    return this.partnerService.PostAddTicketValsys(params).subscribe((output: any) => {
        console.log(output);
        this.setflag(item.id,'successsubmited',true);
        this.setflag(item.id,'prosessubmit',false);

    },error=>{
        console.log(error);
        this.setflag(item.id,'errorsubmited',true);

        this.setflag(item.id,'prosessubmit',false);

    });
  }

  setflag(id,key,val)
  {
    console.log(id,key,val);
    if ( this.flagging[id] == undefined ){
      this.flagging[id] = {};
      this.flagging[id][key] = val;
    }
    if ( this.flagging[id][key] == undefined){
      this.flagging[id][key] = val;
    }

    this.flagging[id][key] = val;
    console.log(this.flagging[id]);
  }

  flag(id,key){
    if ( this.flagging[id] == undefined ){
      this.flagging[id] = {};
      this.flagging[id][key] = false;
    }else if (this.flagging[id][key] == undefined ) {
      this.flagging[id][key] = false;
    }

//    console.log(this.flagging[id]);
//    console.log(this.flagging[id][key]);
    return this.flagging[id][key];
  }

  isPlaybox(id){
    if ( this.ListCustomer[id]['playboxcustomer'] == null) {
      return false;
    }else{
      return true;
    }
  }

  playboxcustomer(id,field)
  {
    if ( !this.isPlaybox(id) ) {
      return '';
    }else{
      return this.ListCustomer[id]['playboxcustomer'][field];
    }
  }

}

